<mat-expansion-panel id="risks" class="bordered" [formGroup]="risks" [class.invalid]="(shipment.highlightInvalid$ | async) && risks.invalid" *ngIf="risks != null">
   <mat-expansion-panel-header>
      <mat-panel-title id="risksPanelTitle">
         Risks
      </mat-panel-title>
   </mat-expansion-panel-header>

   <div>
      <mat-form-field>
         <mat-select id="riskTypeSelect" placeholder="Risk Type" formControlName="type" [required]="config?.items?.type?.required || risks?.errors?.allOf?.includes( config?.allOf?.type?.label )">
            <mat-option id="riskTypeOption" (click)="risks.reset()">None</mat-option>
            <mat-option id="riskTypeOption" *ngFor="let type of riskList" [value]="type">{{type | spacers | titlecase}}</mat-option>
         </mat-select>
      </mat-form-field>

      <mat-form-field class="amount">
         <input id="riskAmountInput" matInput type="number" step="0.01" min="0" placeholder="Amount" formControlName="amount" [required]="config?.items?.amount?.required || risks?.errors?.allOf?.includes( config?.allOf?.amount?.label )">
         <mat-error id="riskAmountError" *ngIf="risks.get('amount').errors as error">
            <ng-container *ngIf="error.required">Required</ng-container>
            <ng-container *ngIf="error.min">Negative amounts not allowed</ng-container>
         </mat-error>
      </mat-form-field>

      <lib-currency-selector id="riskCurrencySelector" formControlName="currency" [required]="config?.items?.currency?.required || risks?.errors?.allOf?.includes( config?.allOf?.currency?.label )"></lib-currency-selector>
   </div>

   <mat-error id="riskError" *ngIf="(shipment.highlightInvalid$ | async)  && risks.invalid" libInputErrors [control]="risks"></mat-error>

   <div class="risks-checkboxes" *ngIf="risks.contains( 'dangerousGoods' )">
      <mat-checkbox id="dangerousGoodsCheckbox" #danger [color]="danger.checked ? 'warn' : ''" formControlName="dangerousGoods">Dangerous Goods</mat-checkbox>
   </div>
</mat-expansion-panel>
